<template>
<div>
  <el-tooltip 
    v-model="tooltipVisible"
    :manual="true"
    :placement="placement"
    >
    <div slot="content" class="max-h-500p overflow-auto" :class="isLower1024 ? 'max-w-[18rem]' : ''"
      @mouseenter="tooltipVisible = true"
      @mouseleave="tooltipVisible = false">
      <span v-if="formatContent" v-html="sanitizedContent"></span>
      <span v-else>{{ content }}</span>
    </div>
    <button
      type="button"
      class="inline-flex rounded-full"
      :aria-label="accessibleLabel"
      :aria-describedby="descriptionId"
      @mouseenter="tooltipVisible = true"
      @mouseleave="tooltipVisible = false"
      @focus="tooltipVisible = true"
      @blur="tooltipVisible = false">
      <base-icon 
        :size="size" 
        name="info" 
        :aria-hidden="true"
        class="cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500 rounded-full" 
        />
    </button>
  </el-tooltip>
  <span :id="descriptionId" class="sr-only">{{ plainContent }}</span>
</div>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'tooltip-icon',
  props: {
    content: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'md'
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: ''
    },
    section: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'right'
    },
  },
  data: function () {
    return {
      tooltipVisible: false,
    }
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    },
    accessibleLabel () {
      if (this.label) return this.label
      if (this.section) return this.$t('app.more_info_about', { section: this.section })
      return this.$t('app.more_info')
    },
    descriptionId () {
      return 'tooltip-icon-desc-' + this._uid
    },
    sanitizedContent () {
      return DOMPurify.sanitize(this.content)
    },
    plainContent () {
      if (!this.formatContent) return this.content
      const el = document.createElement('div')
      el.innerHTML = this.sanitizedContent
      return el.textContent || el.innerText || ''
    }
  },
  created () {
    this._suppressNextEscKeyup = false
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydown, true)
    document.addEventListener('keyup', this.onKeyup, true)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown, true)
    document.removeEventListener('keyup', this.onKeyup, true)
  },
  methods: {
    onKeydown (event) {
      if (event.key === 'Escape' && this.tooltipVisible) {
        this._suppressNextEscKeyup = true
        this.tooltipVisible = false
        event.stopPropagation()
        event.stopImmediatePropagation()
      }
    },
    onKeyup (event) {
      if (event.key === 'Escape' && this._suppressNextEscKeyup) {
        this._suppressNextEscKeyup = false
        event.stopPropagation()
        event.stopImmediatePropagation()
      }
    }
  }
}
</script>
